"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sitemapNode = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
const sitemapNode = exports.sitemapNode = _propTypes.default.shape({
  id: _propTypes.default.string,
  uri: _propTypes.default.sting,
  label: _propTypes.default.string,
  weight: _propTypes.default.number,
  children: _propTypes.default.array
});